export default __webpack_public_path__ + "static/29-0bdb2cf673764a80c6e477e9cd24f341.png";